import {
  getGlobalDefaultDate,
  GLOBAL_MIN_DATE,
  isDateBeforeGlobalMin,
} from '@/core/config/DatePickerConfig';
import moment from 'moment';
import { useStore } from 'vuex';
import { computed } from 'vue';

export { getGlobalDefaultDate } from '@/core/config/DatePickerConfig';

const parseToMoment = (date: Date | string): moment.Moment => {
  if (date instanceof Date) {
    return moment(date);
  }

  const strictParsed = moment(
    date,
    [moment.ISO_8601, "YYYY-MM-DD", "DD/MM/YYYY", "DD-MM-YYYY"],
    true
  );

  if (strictParsed.isValid()) {
    return strictParsed;
  }

  // Avoid moment(dateString) fallback (e.g. Date#toString) which warns.
  const native = new Date(date);
  return moment(native);
};

export const formatDatePayload = (date: Date | string): string => {
  const parsed = parseToMoment(date);

  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
};

export const formatDisplayingDate = (
  date: Date | string | null,
  separatorChar = '-'
) => {
  if (!date) {
    return '-';
  }

  const parsed = parseToMoment(date);

  return parsed.isValid()
    ? parsed.format(`DD${separatorChar}MM${separatorChar}YYYY`)
    : '-';
};

export const useDateTime = () => {
  const store = useStore();

  const currentYear = computed(() => store.getters.getSelectedYear);

  const disableDate = (
    time: Date,
    currentYear: number,
    forBaoCao = false,
    allowBeforeGlobalMin = false
  ) => {
    if (!allowBeforeGlobalMin && isDateBeforeGlobalMin(time)) return true;

    if (time.getFullYear() > currentYear) return true;

    if (time.getFullYear() < currentYear) return true;

    if (forBaoCao && time.getFullYear() === 2023 && time.getMonth() <= 5)
      return true;
  };

  const defaultDate = computed(() => {
    const effectiveDate = getGlobalDefaultDate();
    const selectedYear = +currentYear.value;

    let candidate = new Date(
      selectedYear,
      effectiveDate.getMonth(),
      effectiveDate.getDate()
    );

    if (selectedYear === 2023 && effectiveDate.getMonth() <= 5) {
      const julyFirst = new Date(2023, 6, 1);
      candidate = isDateBeforeGlobalMin(julyFirst)
        ? new Date(GLOBAL_MIN_DATE)
        : julyFirst;
    }

    if (
      selectedYear === GLOBAL_MIN_DATE.getFullYear() &&
      isDateBeforeGlobalMin(candidate)
    ) {
      candidate = new Date(GLOBAL_MIN_DATE);
    }

    return candidate;
  });

  return {
    defaultDate,
    disableDate,
    moment,
    formatDisplayingDate,
    formatDatePayload,
  };
};
